import { CreateColorConvert, HslToRgb } from "@pdfking/renderer-api"
import type { CMYK, RGB } from "pdf-lib"
import { cmyk, rgb } from "pdf-lib"

/**
 * Converts a Color to a PDFLib color format
 * Preserves the original color space:
 * - RGB colors are converted to PDFLib RGB format (array of 3 values)
 * - CMYK colors are converted to PDFLib CMYK format (array of 4 values)
 * - HSL colors are converted to PDFLib RGB format (array of 3 values)
 *
 * All color formats are already in 0-1 range
 */
export const ToPdflibColor = CreateColorConvert<CMYK | RGB>(
  ({ r, g, b }) => rgb(r, g, b),
  ({ c, m, y, k }) => cmyk(c, m, y, k),
  c => {
    const { r, g, b } = HslToRgb(c)
    return rgb(r, g, b)
  }
)
